import { Card, Center, Flex, IconButton, Image, Text } from '@chakra-ui/react';
import { TrashIcon } from 'ui-components/dist/TrashIcon';
import { getWebLinkFaviconImg } from '~/screens/ManageWebLinks/utils';
import { convertPxToRems } from '~/utils-ts';

interface IWebLinksListProps {
  webLinks: string[];
  onRemove: (webLinkIndex: number) => void;
}

export const WebLinksList: React.FC<IWebLinksListProps> = ({
  webLinks,
  onRemove,
}) => (
  <Flex gap="2" flexDirection={'column'} paddingBottom={4} marginTop={4}>
    {webLinks.map((link, index) => (
      <Card
        key={`${index}-${link}`}
        direction={{ base: 'column', sm: 'row' }}
        borderRadius="xl"
        overflow="hidden"
        variant="outline"
        height={convertPxToRems(68)}
        track-id="foam-web-links-link-card"
      >
        <Flex>
          <Center width={convertPxToRems(68)}>
            <Image
              src={getWebLinkFaviconImg(link)}
              objectFit="cover"
              alt={link}
              width={6}
              height={6}
            />
          </Center>
        </Flex>
        <Flex
          width="100%"
          maxWidth="452px"
          flexDirection="column"
          justifyContent="center"
        >
          <Text color="primary.300" fontSize="sm">
            URL
          </Text>
          <Text fontSize="lg" noOfLines={1}>
            {link}
          </Text>
        </Flex>
        <Flex>
          <Center width={convertPxToRems(68)}>
            <IconButton
              aria-label="Add new link"
              size="md"
              isRound={true}
              onClick={() => onRemove(index)}
              icon={<TrashIcon boxSize={4} color="primary.700" />}
              track-id="foam-web-links-remove"
            />
          </Center>
        </Flex>
      </Card>
    ))}
  </Flex>
);
